import { useMutation } from "@/compat/reactQuery";
import queryKeys from "../../../constants/queryKeys";
import reactQueryUtils from "../../../utils/reactQueryUtils";
import riskAssessmentService from "../../services/riskAssessmentService";

const { client } = reactQueryUtils;

// Uploads a new version of a document-only RA and refreshes the view + register.
const useUploadRiskAssessmentVersion = () =>
    useMutation(riskAssessmentService.uploadRiskAssessmentVersion, {
        onSuccess: () => {
            client.invalidateQueries({ queryKey: [queryKeys.riskAssessment] });
            client.invalidateQueries({ queryKey: [queryKeys.riskAssessmentHistory] });
            client.invalidateQueries({ queryKey: [queryKeys.riskAssessments] });
        },
    });

export default useUploadRiskAssessmentVersion;
